import { api } from './client';

export interface PublicUser {
  id: string;
  username: string;
  displayName: string | null;
  avatarUrl: string | null;
}

/** ADR-0055: the photo quota, in bytes. */
export interface StorageUsage {
  usedBytes: number;
  quotaBytes: number;
}

export const usersApi = {
  toggleFollow: (userId: string) =>
    api.post<{ following: boolean }>(`/users/${userId}/follow`).then(r => r.data),

  getFollowingIds: () =>
    api.get<string[]>('/users/following').then(r => r.data),

  getFollowingProfiles: () =>
    api.get<PublicUser[]>('/users/following/profiles').then(r => r.data),

  getStorageUsage: () =>
    api.get<StorageUsage>('/users/me/storage').then(r => r.data),
};
